// モックアップ共有（doc/design/pm-mockup.md）
export default {
  'mockup.tab': 'モックアップ',
  'mockup.empty': 'モックアップはまだありません',
  'mockup.chip.internal': '社内のみ',
  'mockup.chip.shared': '共有中',
  'mockup.chip.sharedUntil': '共有中 · {date} まで',
  'mockup.col.title': 'タイトル',
  'mockup.col.linked': '紐付け先',
  'mockup.col.version': '版',
  'mockup.col.share': '共有',
  'mockup.col.updated': '更新',
  'mockup.linked.task': 'タスク',
  'mockup.linked.bug': 'バグ',
  'mockup.linked.project': 'プロジェクトのみ',
  'mockup.deleteConfirm': '「{title}」を削除しますか？',
  'mockup.deleteHint': 'すべての版が削除され、共有リンクも無効になります。',
  'mockup.edit.title': 'モックアップを編集',
  'mockup.edit.task': '紐付けタスク',
  'mockup.edit.taskHint':
    '空にするとプロジェクト全体のモックアップになります。中身の修正は新しい版として公開してください。',
  'mockup.edit.clearBug': 'バグ {bug} との紐付けを外す',
  'mockup.field.title': 'タイトル',
  'mockup.field.titlePlaceholder': '空欄なら HTML の title タグを使います',
  'mockup.field.note': '変更メモ',
  'mockup.field.notePlaceholder':
    '例：お客様の指摘を反映し保留ステータスを追加',
  'mockup.page.title': 'モックアップ',
  'mockup.page.titleOf': '{name} · モックアップ',
  'mockup.page.subtitle':
    'Claude Code などで作った HTML モックアップを版管理し、顧客・営業と共有します',
  'mockup.page.sharedOnly': '共有中のみ',
  'mockup.page.upload': 'HTML / zip をアップロード',
  'mockup.page.entry': 'モックアップ一覧',
  'mockup.upload.title': 'モックアップを公開',
  'mockup.upload.newVersion': '新しい版をアップロード',
  'mockup.upload.publish': '公開',
  'mockup.upload.drop': 'HTML または zip をドロップ、またはクリックして選択',
  'mockup.upload.hint':
    '.html（5MB まで）または画像などを含む .zip（50MB まで）',
  'mockup.upload.needFile': 'HTML または zip ファイルを選んでください',
  'mockup.upload.done': 'v{v} を公開しました',
  'mockup.upload.error.type':
    '.html または .zip ファイルのみアップロードできます',
  'mockup.upload.error.size':
    '5MB を超える HTML はアップロードできません。画像などを分けた zip にしてください',
  'mockup.upload.error.zipSize': '50MB を超える zip はアップロードできません',
  'mockup.upload.error.empty': 'ファイルが空です',
  'mockup.viewer.close': '閉じる',
  'mockup.viewer.desktop': 'PC',
  'mockup.viewer.tablet': 'タブレット',
  'mockup.viewer.phone': 'スマホ',
  'mockup.viewer.openTab': '別タブで開く',
  'mockup.viewer.newVersion': '新しい版',
  'mockup.viewer.share': '共有…',
  'mockup.viewer.loading': '読み込み中…',
  'mockup.viewer.slow':
    '読み込みに時間がかかっています。しばらくお待ちください。',
  'mockup.version.files': '{n} ファイル',
  'mockup.version.title': '版',
  'mockup.version.deleteConfirm': 'v{v} を削除しますか？',
  'mockup.version.deleteHint':
    '現行版を削除すると、残りの最新版が現行版になります。',
  'mockup.version.shareLatest': '共有リンクは常に最新版を表示します。',
  'mockup.version.sharePinned': '共有リンクは v{v} に固定されています。',
  'mockup.version.notShared': '共有リンクは未発行です。',
  'mockup.share.title': '「{title}」を共有',
  'mockup.share.enable': '共有リンクを有効にする',
  'mockup.share.offHint':
    '有効にすると、ログイン不要で閲覧できるリンクを発行します（既定 30 日）。',
  'mockup.share.link': 'リンク（ログイン不要）',
  'mockup.share.copy': 'コピー',
  'mockup.share.copied': 'コピーしました',
  'mockup.share.copyFailed': 'コピーできませんでした',
  'mockup.share.expiry': '有効期限',
  'mockup.share.days7': '7日',
  'mockup.share.days30': '30日',
  'mockup.share.never': '無期限',
  'mockup.share.until': '{date} まで',
  'mockup.share.noExpiry': '期限なし',
  'mockup.share.version': '相手に見せる版',
  'mockup.share.latest': '常に最新版',
  'mockup.share.pinTo': 'v{v} に固定',
  'mockup.share.views': '閲覧 {n} 回 · 最終 {last}',
  'mockup.share.regenerate': 'リンクを再発行',
  'mockup.share.regenerateConfirm': 'リンクを再発行しますか？',
  'mockup.share.regenerateHint':
    '今のリンクはすぐに使えなくなります。相手には新しいリンクを送り直してください。',
  'mockup.share.regenerated': '新しいリンクを発行しました',
  'mockup.share.done': '完了',
  'mockup.public.invalid':
    'このリンクは無効です。担当者にお問い合わせください。',
  'mockup.public.version': '版 {v} · {date} 更新',
  'mockup.public.validUntil': '{date} まで有効',
};
